import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

interface LocalInitial {
  initial: string;
  active: boolean;
  link: string;
}

@Component({
  selector: 'directory-initials',
  templateUrl: './initials.component.html',
  styleUrls: ['./initials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InitialsComponent {
  @Input() initials: string[];
  @Input() basePath: string;
  @Input() initialActive: string;
  @Input() companies: boolean;

  private readonly allInitials: string[] = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
  ];

  initialClass(): LocalInitial[] {
    return this.allInitials
      .map((initial) => initial.toUpperCase())
      .map((initial) => {
        return {
          initial: initial.toUpperCase(),
          active: (this.initials || []).map((initial2) => initial2.toUpperCase()).includes(initial.toUpperCase()),
          link: `${this.basePath}/${initial.toUpperCase()}`,
        };
      });
  }

  trackByInitial(_: any, initial: LocalInitial): string {
    return initial.initial;
  }
}
